export const GET_INVOICES = "GET_INVOICES";
export const GET_INVOICE_BY_ID = "GET_INVOICE_BY_ID";
export const UPDATE_INVOICE = "UPDATE_INVOICE";
export const DELETE_INVOICE = "DELETE_INVOICE";
export const CREATE_INVOICE = "CREATE_INVOICE";
export const PAY_INVOICE = "PAY_INVOICE";
